//
// begin HIGH CHARTS
// 01
var fn_hc_w1 = function () {
    if ($('.hc-widget__wrapper').length > 0) {

        Highcharts.chart('hc_w1_content', {
            chart: {
                type: 'column'
            },
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            // legend along dots at bottom of widget
            legend: {
                itemStyle: {
                    fontSize: '13px',
                    fontWeight: '500',
                    fontFamily: 'Open Sans'
                }
            },
            xAxis: {
                categories: [
                    'Années'
                ],
                crosshair: true
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Nombre de jours'
                }
            },
            tooltip: {
                enabled: false
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: [{
                name: '2015-2016',
                data: [26],
                color: '#B4D4EB'

            }, {
                name: '2016-2017',
                data: [28],
                color: '#197EC6'

            }]
        })

    }
    //
}
// 02
// See formating: http://jsfiddle.net/highcharts/r4nckaj3/9/
var fn_hc_w2 = function () {
    if ($('.hc-widget__wrapper').length > 0) {

        Highcharts.chart('hc_w2_content', {
            chart: {
                type: 'bar'
            },
            title: {
                text: ''
            },
            xAxis: {
                categories: ['2015-2016', '2016-2017'],
                labels: {
                    rotation: -90,
                    textAlign:'center',
                    style: {
                        fontSize: '13px',
                        fontWeight: '500',
                        fontFamily: 'Open Sans'
                    }
                }
            },
            yAxis: {
                min: 0,
                // max: 100,
                title: {
                    text: 'En pourcentage'
                },
                stackLabels: {
                    enabled: true,
                    rotation:90,
                    textAlign:'center',
                    style: {
                        fontSize: '13px',
                        fontWeight: '700',
                        fontFamily: 'Open Sans'
                    }
                }
            },
            // legend along dots at bottom of widget
            legend: {
                reversed: true,
                itemStyle: {
                    fontSize: '13px',
                    fontWeight: '500',
                    fontFamily: 'Open Sans'
                }
            },
            plotOptions: {
                series: {
                    stacking: 'normal',
                    borderWidth: 0
                    // ,
                    // dataLabels: {
                    //     enabled: true,
                    //     format: '{y}%'
                    // }
                }
            },
            // setting up shared tooltip
            tooltip: {
                headerFormat: '<span style="font-size:0.625rem"></span>',
                pointFormat: '<span style="font-size:1rem; color:{point.color}">● </span> <b>{point.y}</b><br/>',
                shared: true,
                followPointer : true,
                followTouchMove : true
            },
            series: [{
                name: 'Homme',
                data: [80.5, 64.5],
                color: '#B4D4EB'
            }, {
                name: 'Femme',
                data: [19.5, 35.5],
                color: '#814994'
            }]
        })

    }
    //
}
// See: https://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/demo/combo/
// See: http://jsfiddle.net/jlbriggs/j0eq21du/
// See: http://jsfiddle.net/9y4Lj4yr/88/
// See: http://jsfiddle.net/9y4Lj4yr/
var fn_hc_w3 = function () {
    if ($('.hc-widget__wrapper').length > 0) {

        Highcharts.chart('hc_w3_content', {
            title: {
                text: ''
            },
            tooltip: {
                headerFormat: '',
                pointFormat: '<span style="color:{point.color}">\u25CF</span> <b> {point.name}</b>' + ': <b>{point.y}</b>'
            },
            //   xAxis: [{
            //     left: 120, width: 200
            //   }, {
            //     offset: 200,
            //     width: 200
            //   }],
            plotOptions: {
                variablepie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    size: '75%'
                }
            },
            // legend along dots at bottom of widget
            legend: {
                itemStyle: {
                    fontSize: '13px',
                    fontWeight: '500',
                    fontFamily: 'Open Sans'
                }
            },
            series: [
                {
                    type: 'variablepie',
                    name: '2015-2016',
                    data: [{
                        name: 'congé légal',
                        y: 70,
                        z: 10,
                        color: '#B4D4EB'
                    }, {
                        name: 'ancienneté',
                        y: 5,
                        z: 11,
                        color: '#0064A2'
                    }, {
                        name: 'prime de vacances',
                        y: 20,
                        z: 12,
                        color: '#814994'
                    }, {
                        name: 'Fractionnement',
                        y: 5,
                        z: 13,
                        color: '#B5D654'
                    }],
                    center: ['20%', '50%'],
                    // xAxis: 0,
                    minPointSize: 1,
                    innerSize: '70%',
                    zMin: 2,
                    showInLegend: true,
                    dataLabels: {
                        enabled: false,
                        style: {
                            fontSize: '13px',
                            fontWeight: '500',
                            fontFamily: 'Open Sans'
                        }
                    }
                }, {
                    type: 'variablepie',
                    name: '2016-2017',
                    data: [{
                        name: 'congé légal',
                        y: 50,
                        z: 10,
                        color: '#B4D4EB'
                    }, {
                        name: 'ancienneté',
                        y: 5,
                        z: 11,
                        color: '#0064A2'
                    }, {
                        name: 'prime de vacances',
                        y: 40,
                        z: 12,
                        color: '#814994'
                    }, {
                        name: 'Fractionnement',
                        y: 5,
                        z: 13,
                        color: '#B5D654'
                    }],
                    center: ['80%', '50%'],
                    // xAxis: 1,
                    minPointSize: 1,
                    innerSize: '70%',
                    zMin: 2,
                    showInLegend: true,
                    dataLabels: {
                        enabled: false,
                        style: {
                            fontSize: '13px',
                            fontWeight: '500',
                            fontFamily: 'Open Sans'
                        }
                    }
                }
            ]

        })

    }
    //
}
